import PackageRequestsTable from "./package-requests-table";

export default PackageRequestsTable;
